import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { TexteService } from 'src/app/core/services/texte.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ITypesSelection } from 'src/app/core/interfaces/types-selection.interface';
import { IDemandeur } from 'src/app/core/interfaces/demandeur.interface';
import { ToolboxService } from 'src/app/core/services/toolbox.service';

@Component({
    selector: 'app-demandeur-form',
    templateUrl: './demandeur-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DemandeurFormComponent implements OnInit {

  @Input() typesSelected: ITypesSelection;

  public demandeurForm: FormGroup;

  constructor(
    public texteService: TexteService,
    private toolboxService: ToolboxService
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm() {
    this.demandeurForm = new FormGroup({
      nom: new FormControl(''),
      prenom: new FormControl(''),
      lien: new FormControl(''),
      telephone: new FormControl('', this.toolboxService.telValidator()),
      email: new FormControl('', Validators.email)
    });
  }

  public isValid(): boolean {
    return this.demandeurForm.valid;
  }

  public getForm(): IDemandeur {
    if (this.toolboxService.stringIsNullOrWhiteSpace(this.demandeurForm.get('nom').value) &&
      this.toolboxService.stringIsNullOrWhiteSpace(this.demandeurForm.get('prenom').value) &&
      this.toolboxService.stringIsNullOrWhiteSpace(this.demandeurForm.get('lien').value) &&
      this.toolboxService.stringIsNullOrWhiteSpace(this.demandeurForm.get('telephone').value) &&
      this.toolboxService.stringIsNullOrWhiteSpace(this.demandeurForm.get('email').value)) {
      return null;
    }

    return {
      nom: this.demandeurForm.get('nom').value,
      prenom: this.demandeurForm.get('prenom').value,
      lien: this.demandeurForm.get('lien').value,
      telephone: this.demandeurForm.get('telephone').value,
      email: this.demandeurForm.get('email').value,
    } as IDemandeur;
  }
}
